<div class="box-management" *ngIf="items?.length > 0">
  <div class="header-box">
    <div class="title-box">
      <div>
        <i class="app-icon-timer"></i>
      HISTÓRICO DE INTEGRAÇÃO
      </div>
      @if (vehicle?.externalKeys?.length) {
        <div class="externalId">
          Veículo já integrado com código: <span class="code">{{ vehicle.externalKeys[0]?.externalKey }}</span>
        </div>
      }
    </div>
    <button
      *ngIf="canResynchronize()"
      type="button"
      class="resync-btn"
      (click)="onClickResynchronize()"
      [disabled]="isResynchronizing"
      [matTooltip]="isResynchronizing ? 'Ressincronizando histórico de integração...' : 'Ressincroniza o veículo e atualiza o histórico de integração em alguns segundos.'"
      matTooltipPosition="right"
      [attr.title]="isResynchronizing ? 'Ressincronizando veículo' : 'Ressincronizar veículo'"
      [attr.aria-label]="isResynchronizing ? 'Ressincronizando veículo' : 'Ressincronizar veículo'"
    >
      <i class="material-icons" [class.spin]="isResynchronizing">{{ isResynchronizing ? 'autorenew' : 'sync' }}</i>
    </button>
  </div>

  <div class="history-content" [perfectScrollbar]="{ suppressScrollX: true }">
    <div class="timeline">
      <div class="timeline-item" *ngFor="let item of items; let last = last" [class.last]="last">
        <div class="timeline-left">
          <div class="icon-circle" [ngClass]="{ 'icon-ok': item.type === 'SYNCED', 'icon-error': item.type !== 'SYNCED' }">
            <i class="material-icons">{{ item.type === 'SYNCED' ? 'check_circle' : 'error' }}</i>
          </div>
          <div class="timeline-line"></div>
        </div>

        <div class="timeline-right">
          <div class="item-header">
            <span class="item-type-label">{{ getItemTypeLabel(item) }}</span>
          </div>

          <div class="timestamp-top">
            {{ item.createdAt | date: "dd/MM/yyyy" }} às {{ item.createdAt | date: "HH:mm" }}
          </div>

          <div class="diff-container" *ngIf="item.fieldTypes?.length">
            <span class="diff-label">Campos · {{ getItemFieldsLabels(item) }}</span>
          </div>

          <div class="provider-text">
            <small>{{ getItemProviderLabel(item) }}</small>
          </div>

          <div class="details-box" *ngIf="canViewIntegrationHistoryDetails() && item.showingDetails && showDetailsLink(item)">
            <small style="font-size: 9px;" *ngIf="item.method && item.integrationUrl"><b>URL: </b>[{{ item.method }}] {{ item.integrationUrl }}</small>
            <small style="font-size: 9px;" *ngIf="item.requestBody"><br/><b>Request body: </b>{{ item.requestBody }}</small>
            <small style="font-size: 9px;" *ngIf="item.response"><br/><b>Response: </b>{{ item.response }}</small>
          </div>

          <div class="details-link" *ngIf="canViewIntegrationHistoryDetails() && showDetailsLink(item)">
            <span class="link" (click)="openDetailsLink(item)" *ngIf="!item.showingDetails">ver detalhes</span>
            <span class="link" (click)="closeDetailsLink(item)" *ngIf="item.showingDetails">esconder detalhes</span>
          </div>

          <div class="timestamp">
            {{ item.createdAt | date: "dd/MM/yyyy · HH:mm" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-box" *ngIf="showMore && numHistoryItems > 0">
    <span class="view-all-link" (click)="onClickFullHistory()">
      VER TODOS ({{ numHistoryItems }})
    </span>
  </div>
</div>
